import { Flex, IconChevronDownOutline, TextButton, spaceMixin } from '@zillow/constellation';
import styled, { css } from 'styled-components';

export const StyledIconChevron = styled(IconChevronDownOutline)`
  ${(props) =>
    props.$isActive &&
    css`
      transform: rotate(180deg);
      -o-transform: rotate(180deg);
      -moz-transform: rotate(180deg);
    `}
`;

export const StyledDivCaretIcon = styled.div`
  margin-left: ${spaceMixin('xs')};
  svg {
    margin-top: 5px;
  }
`;

export const StyledIconCheckmarkWrapper = styled(Flex)`
  & svg {
    position: absolute;
    right: ${spaceMixin('sm')};
  }
`;

export const StyledTextButton = styled(TextButton)`
  text-decoration: none !important;

  & span {
    margin-right: 0 !important;
  }
`;
